import * as React from 'react';
import {styled} from '../../utils';
import Flex from '../Flex';
import {BaseButtonProps} from './types';

interface RootProps extends Pick<BaseButtonProps, 'disabled' | 'loading' | 'fullWidth'> {}

const Root = styled('button')<RootProps>(({loading, disabled, fullWidth}) => ({
  boxSizing: 'border-box',
  appearance: 'none',
  userSelect: 'none',
  touchAction: 'manipulation',
  background: 'transparent',
  borderColor: 'transparent',
  opacity: loading ? 0.65 : undefined,
  color: disabled ? 'lightgray' : undefined,
  cursor: disabled ? 'not-allowed' : 'pointer',
  display: fullWidth ? 'block' : 'inline-block',
  width: fullWidth ? '100%' : undefined,
  lineHeight: 1.5,
  verticalAlign: 'middle',
  textDecoration: 'none',
  transition: 'all 0.3s',
  '&:focus': {
    outline: 0
  }
}));

export default class BaseButton extends React.Component<BaseButtonProps, {}> {
  public render() {
    const {href, onClick, disabled, loading, children, ...restProps} = this.props;

    if (href) {
      const RootComponent = Root.withComponent('a');
      return (
        <RootComponent
          href={href}
          disabled={disabled || loading}
          loading={loading}
          aria-busy={loading ? true : undefined}
          {...restProps}
        >
          <Flex center={true}>{children}</Flex>
        </RootComponent>
      );
    }
    return (
      <Root
        onClick={onClick}
        disabled={disabled || loading}
        loading={loading}
        aria-busy={loading ? true : undefined}
        {...restProps}
      >
        <Flex center={true}>{children}</Flex>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/BaseButton.tsx